module.exports = __webpack_public_path__ + "img/excel.5698c25a.svg";